// One entry per calendar occurrence: events with days[] (multi-day / scheduled dates) expand to one
// card per day; events without days[] fall back to their top-level date.
export function expandOccurrences(events = []) {
  const out = [];
  events.forEach((e) => {
    if (Array.isArray(e.days) && e.days.length) {
      e.days.forEach((dd) => {
        if (!dd?.date) return;
        out.push({ ...e, date: dd.date, start_time: dd.start_time || e.start_time, end_time: dd.end_time || e.end_time,
          _multiday: true, _occKey: `${e.id}-${dd.date}` });
      });
    } else if (e.date) {
      out.push({ ...e, _occKey: `${e.id}` });
    }
  });
  return out;
}
